import { css } from '@eti/styles';
import { Stack, Heading, Inline, vars } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { useState } from 'react';
import { useTranslation } from '@eti/providers';
import { getSegment, getSeatCharacteristics } from '../utils/seatMapContentUtils';
import { SEATING_PREFERENCE_OPTIONS } from '../utils/constants';
import SeatCharacteristicsPanel from './seatCharacteristics/components/SeatCharacteristicsPanel';
import SeatingLightOrBeside from './SeatingLightOrBeside';
import UnavailableSegment from './UnavailableSegment';
import SeatMapCabinLayout from './SeatMapCabinLayout';
import SeatMapTravelersMobileTabs from './travelerComponent/components/SeatMapTravelersMobileTabs';
import SeatMapTravelersDesktop from './travelerComponent/components/SeatMapTravelersDesktop';
import DeckSelection from './DeckSelection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const seatMapMainContentWrapper = css`
  background-color: ${vars.colors.pageBackdrop};
`;
const seatCharacteristicsPanelStyles = css`
  margin-top: 16px;
`;
const seatMapMainContentMainWrapper = css`
  border-top: 1px solid ${vars.colors.divider};
  width: 100%;
`;
const SeatMapMainContent = _ref => {
  let {
    segments,
    activeSegment,
    activeTraveler,
    getSelected,
    selectedDeck,
    onChange,
    seatTravelers,
    onChangeTraveler,
    onRemoveSeat,
    activeSeatAssignments,
    deckOptions,
    onDeckChange,
    travelerSeatSelectionsBySegment,
    onClose,
    onSaveAndContinue,
    shouldShowSummary
  } = _ref;
  const {
    t
  } = useTranslation();
  const seatingCharacteristicsHeading = t('Product.SeatMap.Characteristics.Label');
  const [expandedCharacteristicKey, setExpandedCharacteristicKey] = useState(null);
  const handleToggle = key => {
    setExpandedCharacteristicKey(prev => prev === key ? null : key);
  };
  const currentSegment = getSegment(segments, activeSegment);
  const isSeatingPreferenceAvailable = (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE;
  const {
    __typename,
    price
  } = currentSegment || {};
  const seatCharacteristics = getSeatCharacteristics(segments, activeSegment);
  const isDesktop = useMediaQuery(`(min-width: 1200px)`);
  const showContentOnMobile = !isSeatingPreferenceAvailable && (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.isAvailable) && !isDesktop;
  const showContentOnDesktop = !isSeatingPreferenceAvailable && (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.isAvailable) && isDesktop;
  const isSegmentUnavailable = !isSeatingPreferenceAvailable && (!currentSegment || !currentSegment.isAvailable);
  return /*#__PURE__*/_jsxs(Stack, {
    className: seatMapMainContentMainWrapper,
    "data-testid": "seatMap-maincontent",
    children: [showContentOnMobile && /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [/*#__PURE__*/_jsx(SeatMapTravelersMobileTabs, {
        activeSeatAssignments: activeSeatAssignments,
        activeSegment: activeSegment,
        activeTraveler: activeTraveler,
        onChange: onChangeTraveler,
        onRemoveSeat: onRemoveSeat,
        seatTravelers: seatTravelers
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [deckOptions.length > 1 && /*#__PURE__*/_jsx(DeckSelection, {
          onDeckChange: onDeckChange,
          options: deckOptions
        }), /*#__PURE__*/_jsx(SeatMapCabinLayout, {
          activeSegment: activeSegment,
          currentSegment: currentSegment,
          onChange: onChange,
          onClose: onClose,
          onSaveAndContinue: onSaveAndContinue,
          seatCharacteristics: seatCharacteristics,
          seatTravelers: seatTravelers,
          selectedDeck: selectedDeck,
          shouldShowSummary: shouldShowSummary,
          travelerSeatSelectionsBySegment: travelerSeatSelectionsBySegment
        })]
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "center",
      className: seatMapMainContentWrapper,
      noWrap: true,
      spacing: 8,
      children: [showContentOnDesktop && /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        children: [/*#__PURE__*/_jsx(SeatMapTravelersDesktop, {
          activeSeatAssignments: activeSeatAssignments,
          activeSegment: activeSegment,
          activeTraveler: activeTraveler,
          onChange: onChangeTraveler,
          onRemoveSeat: onRemoveSeat,
          seatTravelers: seatTravelers
        }), /*#__PURE__*/_jsxs(Stack, {
          children: [deckOptions.length > 1 && /*#__PURE__*/_jsx(DeckSelection, {
            onDeckChange: onDeckChange,
            options: deckOptions
          }), /*#__PURE__*/_jsx(SeatMapCabinLayout, {
            activeSegment: activeSegment,
            currentSegment: currentSegment,
            onChange: onChange,
            onClose: onClose,
            onSaveAndContinue: onSaveAndContinue,
            seatTravelers: seatTravelers,
            selectedDeck: selectedDeck,
            shouldShowSummary: shouldShowSummary,
            travelerSeatSelectionsBySegment: travelerSeatSelectionsBySegment
          })]
        }), /*#__PURE__*/_jsxs(Stack, {
          children: [/*#__PURE__*/_jsx(Heading, {
            className: seatCharacteristicsPanelStyles,
            level: 3,
            children: seatingCharacteristicsHeading
          }), seatCharacteristics === null || seatCharacteristics === void 0 ? void 0 : seatCharacteristics.map(_ref2 => {
            let {
              characteristic,
              price: minimumPrice
            } = _ref2;
            const key = characteristic;
            return /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
              characteristic: characteristic,
              isOpen: expandedCharacteristicKey === key,
              onToggle: () => handleToggle(key),
              priceFrom: minimumPrice
            }, key);
          }), /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
            isOpen: expandedCharacteristicKey === 'unavailable',
            isUnavailable: true,
            onToggle: () => handleToggle('unavailable')
          })]
        })]
      }), isSeatingPreferenceAvailable && /*#__PURE__*/_jsx(SeatingLightOrBeside, {
        activeSegment: activeSegment,
        onChange: onChange,
        price: price,
        selectedSeatPreference: getSelected(activeSegment),
        typename: __typename
      }), isSegmentUnavailable && /*#__PURE__*/_jsx(UnavailableSegment, {})]
    })]
  });
};
export default SeatMapMainContent;
//# sourceMappingURL=SeatMapMainContent.js.map